<div class="links">
  <table class="links_table">
    <tr class="links_table-header">
      <th class="links_table-header-title">{{ 'Title' | transloco }}</th>
      <th class="links_table-header-action">{{ 'Action' | transloco }}</th>
    </tr>

    @for (link of links; track link.id) {
      <tr class="links_table-row" [attr.data-testid]="'node-detail-popover-links_table-row-' + link.title">
        <td class="links_title">
          <div class="links_icon" [ttTooltip]="link.toUrl">
            <mat-icon [icon]="link.icon" [iconSize]="14" />
          </div>
          <span class="links_title-text" [attr.data-testid]="'node-detail-popover-links_title'">{{ link.title }}</span>
        </td>
        <td class="links_action" [ttTooltip]="link.toUrl">
          <div class="links_action_wrapper">
            <a [attr.data-testid]="'node-detail-popover-links_button-action'" (click)="handleLinkClick(link)">
              {{ link.translationKey | transloco: { link: link.toUrl } }}
              @if (link.toUrl) {
                ({{ 'External' | transloco }})
              }
            </a>
            @if (link.description) {
              <mat-icon class="links_action_icon" [icon]="'note'" [iconSize]="12" [ttTooltip]="link.description | wrapFn: getTextContent" />
            }
          </div>
        </td>
      </tr>
    }
  </table>
</div>
